var exports = {
  "a": "Box__64Gexx",
  "w": "Box_1__IR5zZq",
};

module.exports = exports;
